import { OWebApp } from "oweb";
import { SXQuestion, SXSurvey } from "@/gobl.bundle";
import ServiceStore from "./default";

export default class SurveysStore extends ServiceStore<SXSurvey> {
	constructor(app: OWebApp) {
		super(app, SXSurvey, "surveys");
	}

	surveyQuestions(s: SXSurvey): SXQuestion[] {
		return this.itemRelation<SXQuestion[]>(s, "questions") || [];
	}
}
